import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { Contrato } from '../shared/models/contrato.model';
import { StepperNavigationService } from '../shared/services/stepper-navigation.service';

@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.scss']
})
export class ContractsComponent implements OnInit {

  @Input()
  contratos: Array<Contrato>;

  @Output()
  emitContratoSelecionado = new EventEmitter<Contrato>();

  contratoSelecionado: Contrato;

  constructor(
    private stepperNav: StepperNavigationService
  ) { }

  @Input()
  stepper: MatStepper;

  ngOnInit() {}

  emitirContrato(contrato: Contrato): void {
    this.emitContratoSelecionado.emit(contrato);
  }

  selecionarContrato(contrato: Contrato): void {
    this.contratoSelecionado = contrato;
    this.emitirContrato(contrato);
  }
}
